type Params = {
  type: 'create' | 'edit' | 'preview';
  participantCount: number;
  isRoundRobinSelected: boolean;
};

export const isPanelTypeSelectorVisible = ({
  type,
  participantCount,
  isRoundRobinSelected
}: Params): boolean => {
  // Round robin demands two interviewers, so the control that escapes it has to
  // stay on screen — hiding it leaves the form unsubmittable with nothing to change.
  if (isRoundRobinSelected) {
    return true;
  }

  // Collective is fixed once the template exists, and only a choice at all once
  // there is more than one interviewer.
  return type === 'create' && participantCount > 1;
};
